import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../queries/useApplicationCache';

/**
 * Reads the Fix-Flip Budget form for a given property from the React Query application cache.
 */
export function useBudgetFixFlipCache(propertyGuid: string): IBudgetFixFlip | undefined {
    return useApplicationCache(d =>
        d.information?.properties?.forms?.find(
            f => f.type === 'Fix-Flip' && f.propertyGuid === propertyGuid
        ) as IBudgetFixFlip | undefined
    );
}
